import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

const FormSelect = ({
  color = 'primary',
  variant = 'filled',
  name,
  title = '',
  options = [],
  disabled = false,
  onChange,
  size = 'small',
  formik: {
    values = {},
    errors = {},
    handleChange
  }
}) => {
  return /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    variant: variant,
    color: color
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: name + '-label'
  }, title), /*#__PURE__*/React.createElement(Select, {
    size: size,
    labelId: name + '-label',
    id: name,
    value: values[name],
    label: title ? `${title} (${name})` : name,
    onChange: async (e, child) => {
      handleChange && (await handleChange(e));
      onChange && (await onChange(e, child));
    },
    name: name,
    disabled: disabled
  }, options.map((item, index) => /*#__PURE__*/React.createElement(MenuItem, {
    key: index,
    value: item.value,
    divider: item.divider
  }, item.label || item.value))), errors[name] && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors[name]));
};

export { FormSelect };
